import { sendPasswordResetEmail } from "firebase/auth";
import { useState } from "react";
import { auth } from "../utils/db";
import { useHistory } from "react-router-dom";
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";
import {
  IonButton,
  IonCardTitle,
  IonCol,
  IonContent,
  IonInput,
  IonLabel,
  IonPage,
  IonRouterLink,
  IonRow,
  IonText,
  useIonToast,
} from "@ionic/react";

export default function PasswordReset() {
  const [email, setEmail] = useState("");
  const [presentToast] = useIonToast();
  const history = useHistory();

  const isFormValid = email.trim() !== "";

  const resetPassword = async () => {
    try {
      await sendPasswordResetEmail(auth, email);
      presentToast({
        header: "Verifique o seu email",
        message: "Email para redefinição de senha foi enviado.",
      });

      history.push("/");
    } catch (err) {
      presentToast({
        header: "Erro ao redefinir a senha",
        message: err.message,
        buttons: ["OK"],
      });
    }
  };

  return (
    <IonPage className="gray-page">
      <IonContent fullscreen>
        <div className="box">
          <IonRow>
            <IonCol size="12">
              <IonCardTitle>Redefinir Senha</IonCardTitle>
            </IonCol>
          </IonRow>
          <IonRow className="ion-margin-top ion-padding-top">
            <IonCol size="12">
              <IonLabel>Email</IonLabel>
              <IonInput
                placeholder="Email"
                onChange={(e) => setEmail(e.target.value)}
              />
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol size="12">
              <IonButton
                expand="full"
                shape="round"
                color="tertiary"
                disabled={!isFormValid}
                onClick={resetPassword}
              >
                Redefinir Senha
              </IonButton>
            </IonCol>
          </IonRow>
          <IonRow className="ion-margin-top ion-padding-top">
            <IonCol size="12">
              <IonText>Voltar para o login?</IonText>
              <IonRouterLink className="link" href="/login">
                {" "}
                Clique aqui.
              </IonRouterLink>
            </IonCol>
          </IonRow>
        </div>
      </IonContent>
    </IonPage>
  );
}
